import React from "react";
import { env } from "../config";

function CloudStackDarkCards(props: any) {
    const { title, description, Features } = props;
    return (
        <div className="bg-[#212121] font-custom">
            <div
                className={`text-white  px-5 py-7 lg:px-10 xl:px-20 lg:py-14 mx-auto max-w-screen-2xl `}
            >
                <div
                    className={`text-2xl md:text-4xl lg:text-5xl max-w-[35ch] flex justify-center mb-3 mx-auto  leading-loose text-center font-custom font-bold`}
                >
                    {title}
                </div>
                <div className="lg:text-lg md:text-base  font-normal  pt-2  text-center mb-7">
                    {description}
                </div>

                <div className=" grid  md:grid-cols-2 lg:grid-cols-3 gap-3 bg-[#212121]">
                    {Features?.map((node: any, index: number) => {
                        return (
                            <div
                                data-aos="fade-left"
                                data-aos-delay={`${index === 0 ? 150 : index * 150}`}
                                className={`  p-6 rounded-[10px] border border-[#F08300]  lg:h-auto flex flex-col  md:text-left md:items-start justify-evenly`}
                            >
                                {node?.Image?.data?.attributes?.url && (
                                    <img
                                        className="w-max"
                                        src={`${env}${node?.Image?.data?.attributes?.url}`}
                                        alt="not available"
                                    />
                                )}

                                <div className="font-bold font-custom  md:text-base text-base py-3">
                                    {node?.Title}
                                </div>
                                <div className="font-custom md:text-base text-base  ">
                                    {node?.Description}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}

export default CloudStackDarkCards;
